/*
  AGNTC 2026-08-13 — fill the selected-option name beside each option legend.

  THE BUG: every product template renders

      <legend>Color: <span class="optionselected"></span></legend>

  ...and no JS anywhere in the theme ever writes to that span. Verified with
  `grep -rn optionselected assets/*.js` — zero hits, while five sections render
  it (main-product, main-product-game, main-product-wip, featured-product,
  landing-featured-product). So every PDP on the store shows a permanently blank
  "Color:" and "Size:". The slot was built and then never wired up.

  Not reported by Astrid — found while fixing her colour-swatch item on 13 Aug.
  It is the same complaint one layer deeper: her note was "color buttons have no
  color name on hover over", and the hover bubble now answers that
  (product.css, AGNTC PDP size pills + colour swatch names). This answers the
  quieter half — what is currently selected, without hovering anything. It also
  helps the "nobody knows what Nood 3/5/7/9 are" problem, because the chosen
  shade is now named in the buy box.

  CSS could not do this: the value lives in a checked <input> / <select> that is
  not an ancestor or sibling of the span, so there is no selector that reaches it.

  SCOPE RESOLUTION — why the walk-up rather than a fixed selector.
  Two different markups render this span:

    radios    fieldset.product-form__input > .product-form_inputs-wrp
                > legend > span.optionselected
                + .option-grid > label.customradio > input[type=radio]

    dropdown  .product-form__input--dropdown
                > label > span.optionselected
                + .select > select

  In the first the control is a cousin; in the second it is an uncle. Walking up
  to the NEAREST ancestor that actually contains a control handles both, and
  "nearest" is what keeps a Size legend from reading the Color radios — stopping
  at the first match is the correctness argument, not an optimisation.
*/
(function () {
  'use strict';

  function scopeOf(span) {
    var n = span.parentElement;
    while (n && n !== document.body) {
      if (n.querySelector('input[type="radio"], select')) return n;
      n = n.parentElement;
    }
    return null;
  }

  function valueIn(scope) {
    var radio = scope.querySelector('input[type="radio"]:checked');
    if (radio) {
      // Prefer the label's data-name: it is the human string the swatch tooltip
      // and the quick-add chips already use, so the three cannot drift apart.
      // Falls back to the input value, which is the same text on every template
      // checked — data-name is simply the one the theme treats as display copy.
      var label = radio.closest('label[data-name]');
      return (label && label.getAttribute('data-name')) || radio.value || '';
    }
    var sel = scope.querySelector('select');
    if (sel) {
      var opt = sel.options[sel.selectedIndex];
      return (opt && opt.textContent.trim()) || sel.value || '';
    }
    return '';
  }

  function refresh() {
    document.querySelectorAll('.optionselected').forEach(function (span) {
      var scope = scopeOf(span);
      if (!scope) return;
      var v = valueIn(scope);
      // Only touch the DOM when it would actually change, so this cannot fight
      // a MutationObserver-driven re-render into a loop.
      if (span.textContent !== v) span.textContent = v;
    });
  }

  // Delegated: radios and selects both bubble `change`, and the option controls
  // are re-rendered on variant change, so binding per element would go stale.
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches) return;
    if (e.target.matches('input[type="radio"], select')) refresh();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  // The theme swaps the whole variant block on variant change (and the theme
  // editor reloads sections without firing DOMContentLoaded again), which would
  // otherwise restore the blank span the moment a shopper picks anything.
  document.addEventListener('shopify:section:load', refresh);

  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      // Coalesce: a section swap fires many records for one logical change.
      requestAnimationFrame(function () { pending = false; refresh(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
